import React, { Component } from "react"
import PropTypes from "prop-types"
import "./textField.scss"

class TextField extends Component {
  componentDidUpdate(prevProps) {
    this.props.shouldAutofocus && !this.props.hasFocused
      ? this._input.focus()
      : null
  }

  handleBlur = (e) => {
    e.persist()
    if (this.props.shouldAutofocus) {
      this.props.onChangeFocus()
    }
    if (this.props.onBlur) {
      this.props.onBlur(e)
    }
  }
  handleFocus = (e) => {
    if (this.props.onFocus) {
      this.props.onFocus(e)
    }
  }

  render() {
    const {
      id,
      value,
      defaultValue,
      type,
      placeholder,
      label,
      classes,
      disabled,
      errors,
      fullWidth,
      onChange,
      errorOptions,
      name,
      required,
      optional,
      dataCy,
    } = this.props

    const styles = {
      width: fullWidth ? "100%" : "auto",
    }
    return (
      <div
        className={`TextFieldGroup ${
          errorOptions && errorOptions.showMessage ? "errors" : ""
        } ${
          errorOptions && errorOptions.position && errorOptions.showMessage
            ? errorOptions.position
            : ""
        }`}
      >
        {label && (
          <label>
            {label} {required && "*"} {optional && <i>(optional)</i>}
          </label>
        )}
        {errorOptions && errorOptions.showMessage && error(this.props)}
        {!label && required && <span className="required">*</span>}
        <input
          key={"TextFieldInput"}
          id={id}
          style={styles}
          className={`form-control ${classes ? classes.join(" ") : ""} ${
            errors && errorOptions.outline && errorOptions.hasError
              ? "input-error"
              : ""
          }`}
          placeholder={placeholder}
          defaultValue={defaultValue}
          type={type ? type : "text"}
          disabled={disabled}
          onChange={onChange}
          value={value}
          name={name}
          onBlur={this.handleBlur}
          onFocus={this.handleFocus}
          ref={(input) => (this._input = input)}
          data-cy={dataCy}
        />
      </div>
    )
  }
}

TextField.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.string,
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  classes: PropTypes.arrayOf(PropTypes.string),
  disabled: PropTypes.bool,
  errors: PropTypes.bool,
  errorMessages: PropTypes.string,
  fullWidth: PropTypes.bool,
  labelTop: PropTypes.bool,
  errorsTop: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  required: PropTypes.bool,
  shouldAutofocus: PropTypes.bool,
  errorOptions: PropTypes.shape({
    showMessage: PropTypes.bool,
    position: PropTypes.string,
    message: PropTypes.string,
    outline: PropTypes.bool,
    hasError: PropTypes.bool,
  }),
  optional: PropTypes.bool,
  dataCy: PropTypes.string,
}

const error = (props) => {
  return (
    <div key={"inputError" + Math.random()} className="errorMessage">
      <p>{props.errorOptions.message}</p>
    </div>
  )
}

export default TextField
